import { useQuery } from '@apollo/client'
import React from 'react'

import { LoadingSpinner, timingSlowerMs } from '@syconium/little-miss-figgy'

import { reportClientError } from '../../../../app/_components/chrome/scripts/DataDogRumScript'
import { useTranslation } from '../../../../app/_providers/TranslationProvider.client'
import { FitModel } from '../../../../types/graphql'
import { TrayModal } from '../../TrayModal'
import { FitModelTileLayout } from '../FitModelTileLayout'

import { FETCH_FIT_MODELS } from './queries'
import { Content, Loading } from './styles'

export const FitModelModal: React.FC<{
  activeFitModel: FitModel
  deprecatedFeaturedProduct: {
    handle: string | null | undefined
  }
  isModalOpen: boolean
  onRequestClose(): void
  selectFitModel(x: FitModel): void
}> = ({
  activeFitModel,
  isModalOpen,
  onRequestClose,
  selectFitModel,
  deprecatedFeaturedProduct,
}) => {
  const {
    fitModel: strings,
    loadMoreButton: { loading: loadingLabel },
  } = useTranslation()

  const { data } = useQuery<{
    fitModels: {
      nodes: FitModel[]
    } | null
  }>(FETCH_FIT_MODELS, {
    onError(error) {
      reportClientError({
        error,
        context: {
          scope: 'FitModelModal',
        },
      })
    },
    variables: { handle: deprecatedFeaturedProduct.handle! },
  })
  const { nodes: fitModels } = data?.fitModels ?? {}

  const clickTimeoutRef = React.useRef<NodeJS.Timeout>()
  const cleanupClickTimeout = () => {
    if (clickTimeoutRef.current) clearTimeout(clickTimeoutRef.current)
  }
  React.useEffect(() => cleanupClickTimeout, [])

  const onTileClick = (fitModel: FitModel) => {
    selectFitModel(fitModel)
    cleanupClickTimeout()
    clickTimeoutRef.current = setTimeout(onRequestClose, timingSlowerMs)
  }

  return (
    <TrayModal {...{ isModalOpen, onRequestClose }} title={strings.switchModel}>
      <Content>
        {fitModels ? (
          <FitModelTileLayout {...{ activeFitModel, fitModels, onTileClick }} />
        ) : (
          <Loading>
            <LoadingSpinner label={loadingLabel} />
          </Loading>
        )}
      </Content>
    </TrayModal>
  )
}
